import { Camera, LineChart, Sparkles, MessagesSquare, Wrench } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
    {
        num: "01",
        icon: Camera,
        title: "Photos pro & direction artistique",
        desc: "Shooting professionnel, home staging léger et mise en scène lumineuse. Votre annonce se démarque en 3 secondes — c'est là que tout se joue.",
        span: "lg:col-span-2",
        img: "https://images.pexels.com/photos/18631360/pexels-photo-18631360.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        num: "02",
        icon: LineChart,
        title: "Tarification dynamique",
        desc: "Prix ajustés chaque nuit selon la demande, les événements et la saison. Votre taux d'occupation monte, vos revenus aussi.",
    },
    {
        num: "03",
        icon: Sparkles,
        title: "Ménage & linge hôtelier",
        desc: "Équipes de ménage 5*, linge de maison immaculé et produits d'accueil après chaque départ. Le standard d'un palace, chez vous.",
        span: "",
        img: "https://images.pexels.com/photos/7821343/pexels-photo-7821343.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        num: "04",
        icon: MessagesSquare,
        title: "Voyageurs & communication 24/7",
        desc: "Sélection rigoureuse des voyageurs, réponses en moins de 15 minutes, gestion des remises de clés et états des lieux complets.",
    },
    {
        num: "05",
        icon: Wrench,
        title: "Maintenance & intendance",
        desc: "Petites réparations, réassort, urgence technique : notre réseau d'artisans intervient sans que vous ayez à décrocher votre téléphone.",
        span: "lg:col-span-2",
    },
];

export default function ServicesManifesto() {
    return (
        <section id="services" data-testid="services-section" className="relative mx-auto max-w-7xl px-6 py-28">
            <Reveal>
                <p className="eyebrow mb-6 flex items-center gap-3">
                    <span className="inline-block h-px w-10 bg-[#8A7563]" />
                    Le manifeste — 5 chapitres
                </p>
                <h2 className="font-display max-w-2xl text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
                    Tout ce que votre location exige, <span className="italic text-[#8A7563]">sans vous.</span>
                </h2>
            </Reveal>

            <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.08} className={s.span || ""}>
                        <article
                            data-testid={`service-card-${s.num}`}
                            className="group relative h-full overflow-hidden rounded-2xl border border-[#2B2622]/10 bg-[#FFFFFF]/70 p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#8A7563]/40 hover:shadow-[0_24px_60px_rgba(90,79,68,0.18)]"
                        >
                            {s.img && (
                                <div className="absolute inset-0 opacity-0 transition-opacity duration-700 group-hover:opacity-100">
                                    <img src={s.img} alt="" className="h-full w-full object-cover opacity-15" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#FFFFFF] via-[#FFFFFF]/70 to-transparent" />
                                </div>
                            )}
                            <div className="relative">
                                <div className="flex items-start justify-between">
                                    <span className="font-display text-5xl font-semibold text-[#8A7563]/25 transition-colors duration-500 group-hover:text-[#8A7563]/60">
                                        {s.num}
                                    </span>
                                    <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#8A7563]/25 bg-[#8A7563]/8 text-[#8A7563] transition-all duration-500 group-hover:bg-[#8A7563] group-hover:text-[#FAF8F5]">
                                        <s.icon size={18} strokeWidth={1.75} />
                                    </span>
                                </div>
                                <h3 className="font-display mt-6 text-2xl font-semibold">{s.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-[#8A7F72]">{s.desc}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
